module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/videos/term-bg-1-cd770329768bfa9ddd2880ffa6fd2883.jpg";